import { render, staticRenderFns } from "./Queues.vue?vue&type=template&id=6a4fc3d6"
import script from "./Queues.vue?vue&type=script&lang=js"
export * from "./Queues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports